import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, GraduationCap } from 'lucide-react';
import { Button } from '../components/ui/button';
import DemoChat from '../components/DemoChat';

const DemoPage = () => {
  const navigate = useNavigate();

  const handleComplete = (action) => {
    if (action === 'signup') {
      navigate('/register');
    } else {
      navigate('/');
    }
  };

  return (
    <div className="h-screen flex flex-col bg-white">
      {/* Minimal Header */}
      <header className="flex items-center justify-between px-4 py-3 border-b border-slate-200">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => navigate('/')}
          className="rounded-full"
          data-testid="demo-back-btn"
        >
          <ArrowLeft className="w-5 h-5" />
        </Button>
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-ocean-blue flex items-center justify-center">
            <GraduationCap className="w-4 h-4 text-white" />
          </div>
          <span className="font-semibold text-ocean-blue">Minnow School</span>
        </div>
        <div className="w-10" /> {/* Spacer for centering */}
      </header>

      {/* Full-screen Chat */}
      <main className="flex-1 overflow-hidden">
        <DemoChat onComplete={handleComplete} variant="mobile" />
      </main>
    </div>
  );
};

export default DemoPage;
